<!-- =========================================================================================
File Name: TableDefault.vue
Description: Rendering default table
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vx-card :title="nameTipology || $t('Name') + ':' + ` ${typology_local.label}`" :subtitle="schema.name" no-shadow>
		<template slot="actions">
			<vs-dropdown
				vs-trigger-click
				class="ml-auto md:block hidden cursor-pointer"
				v-if="showEditIcon && objectsUpdatePermission"
			>
				<vs-button icon="icon-edit" icon-pack="feather" radius />

				<vs-dropdown-menu class="w-48">
					<vs-dropdown-item>
						<div @click="additionalFieldsEnable = !additionalFieldsEnable" class="flex items-center">
							<feather-icon icon="EditIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
							<span>{{ $t("Object.EnableEditing") }}</span>
						</div>
					</vs-dropdown-item>
					<vs-dropdown-item v-if="additionalFieldsEnable">
						<div @click="updateCategory" class="flex items-center">
							<feather-icon icon="SaveIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
							<span>{{ $t("Object.SaveChanges") }}</span>
						</div>
					</vs-dropdown-item>
					<vs-dropdown-item>
						<div @click="activePrompt = true" class="flex items-center">
							<feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
							<span>{{ $t("Object.ChangeName") }}</span>
						</div>
					</vs-dropdown-item>
					<vs-dropdown-item v-if="objectsDeletePermission">
						<div @click="confirmDeleteCategory" class="flex items-center">
							<feather-icon icon="TrashIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
							<span>{{ $t("Crud.Delete") }}</span>
						</div>
					</vs-dropdown-item>
				</vs-dropdown-menu>
			</vs-dropdown>
		</template>

		<div :collapse-action="true" v-if="defaultAction === 'CREATE' || defaultAction === 'DEFINITION'">
			<div class="vx-row">
				<div class="vx-col sm:w-1/3 w-full mb-2" v-if="defaultAction === 'CREATE'">
					<label class="vs-input--label">{{ $t("Object.ObjectName") }}</label>
					<v-select
						v-validate="'required'"
						name="typology"
						v-model="typology_local"
						:clearable="false"
						:disabled="!additionalFieldsEnable"
						:options="listTipologies"
					>
						<template v-slot:no-options="{search, searching}">
							<template v-if="searching">
								{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
							</template>
						</template>
					</v-select>
				</div>

				<div class="vx-col sm:w-1/3 w-full mb-2">
					<vs-tooltip color="success" :text="$t('TooltipSchemas')" position="right">
						<label class="vs-input--label">{{ $t("ObjectType") }} </label>
						<span><vs-icon icon="info" color="primary"></vs-icon></span>
					</vs-tooltip>
					<v-select
						v-model="category_local"
						:clearable="false"
						:options="nameOptions"
						v-validate="'required'"
						name="cat"
					>
						<template v-slot:no-options="{search, searching}">
							<template v-if="searching">
								{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
							</template>
						</template>
					</v-select>
					<span class="text-danger text-sm" v-show="errors.has('cat')">{{
						$t("Object.ValidMessages.cat")
					}}</span>
				</div>
			</div>

			<p class="mb-3 g-label--normal" v-if="numProperties > 0">
				{{ $t("Object.NumProperties") }}
			</p>
		</div>

		<div v-if="defaultAction === 'LIST'">
			<p>{{ $t("Description") }}: {{ schema.typologyData.description }}</p>
		</div>

		<div class="contained-example-container">
			<div id="div-with-loading" class="vs-con-loading__container">
				<!-- SECTION COLLAPSE FOR THE TABLAS-->
				<!-- Collapse -->
				<div class="vx-col w-full">
					<vx-card
						class="card-secondary"
						collapse-action
						no-shadow
						card-border
						:title="$t('Object.PrincipalFields')"
					>
						<!-- TABLE PRINCIPAL PROPERTIES-->
						<vs-table :data="principalProperties" v-if="numProperties > 0">
							<template slot="thead">
								<vs-th>{{ $t("Name") }}</vs-th>
								<vs-th>{{ $t("Object.Label") }}</vs-th>
								<vs-th>{{ $t("Object.TypeField") }}</vs-th>
							</template>

							<template slot-scope="{data}">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data">
									<vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
									<vs-td :data="data[indextr].label">{{ data[indextr].label }}</vs-td>
									<vs-td :data="data[indextr].type">{{ data[indextr].type }}</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</vx-card>
				</div>

				<!-- Collapse -->
				<div class="vx-col w-full mb-base mt-base">
					<vx-card
						class="card-secondary"
						collapse-action
						no-shadow
						card-border
						:title="$t('Object.AdditionalFields')"
					>
						<!-- TABLE ADDITIONAL PROPERTIES-->
						<vs-table :data="additionalProperties" v-if="numProperties > 0">
							<template slot="thead">
								<vs-th>{{ $t("Name") }}</vs-th>
								<vs-th>{{ $t("Object.Label") }}</vs-th>
								<vs-th>{{ $t("Object.TypeField") }}</vs-th>
								<vs-th>{{ $t("Object.Required") }}</vs-th>
								<vs-th>{{ $t("Actions") }}</vs-th>
							</template>

							<template slot-scope="{data}">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data">
									<vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
									<vs-td :data="data[indextr].label">{{ data[indextr].label }}</vs-td>
									<vs-td :data="data[indextr].type">{{ data[indextr].type }}</vs-td>
									<vs-td :data="data[indextr].required">
										<vs-chip
											:color="getRequiredColor(data[indextr].required)"
											class="product-order-status"
											>{{ isRequired(data[indextr].required) }}
										</vs-chip>
									</vs-td>
									<vs-td>
										<feather-icon
											v-if="additionalFieldsEnable"
											icon="Trash2Icon"
											svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
											@click="confirmDeleteField(data[indextr])"
										/>

										<feather-icon
											v-if="additionalFieldsEnable"
											icon="EditIcon"
											svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
											@click="editSelect(data[indextr])"
										/>
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>

						<!-- Dropdown Button 1 -->
						<div
							class="dropdown-button-container"
							v-if="additionalFieldsEnable && category_local.value !== 'LAYER'"
						>
							<vs-dropdown vs-trigger-click class="cursor-pointer">
								<vs-button class="btn-drop mt-base" type="filled" icon="expand_more" icon-after
									>{{ $t("Add") }} {{ $t("Object.AdditionalField") }}
								</vs-button>
								<vs-dropdown-menu>
									<vs-dropdown-group :vs-label="$t('Object.Basics')">
										<vs-dropdown-item
											v-for="field in fieldTypes"
											:key="field.value"
											@click="openFieldPromp(field)"
										>
											<div class="flex flex-wrap items-center">
												<i class="material-icons inline-block mr-2">
													{{ field.icon }}
												</i>
												<span>{{ field.label }}</span>
											</div>
										</vs-dropdown-item>
									</vs-dropdown-group>
								</vs-dropdown-menu>
							</vs-dropdown>
						</div>
					</vx-card>
				</div>
			</div>
		</div>

		<vs-prompt
			:title="$t('Object.ChangeObjectName')"
			@cancel="val = ''"
			@accept="updateTypology"
			@close="close"
			:active.sync="activePrompt"
			:acceptText="$t('Accept')"
			:cancelText="$t('Cancel')"
		>
			<div class="mt-2">
				<span>{{ $t("Object.EnterNewName") }}</span>
				<vs-input :placeholder="$t('Name')" :vs-placeholder="$t('Name')" v-model="val" class="mt-3 w-full" />
			</div>
		</vs-prompt>

		<vs-prompt
			:title="$t('Object.PropertyDefinition')"
			@cancel="close"
			@accept="setValue"
			@close="close"
			:active.sync="activePromptField"
			:acceptText="$t('Accept')"
			:cancelText="$t('Cancel')"
		>
			<div class="mt-2">
				<small class="date-label">{{ $t("Object.Label") }}: ({{ $t("Object.LabelHelp") }})</small>
				<vs-input
					v-if="field.type.value === 'select'"
					:placeholder="$t('Object.Label')"
					:vs-placeholder="$t('Object.Label')"
					v-model.trim="fieldName"
					class="w-full"
				/>
				<vs-input
					v-else
					:placeholder="$t('Object.Label')"
					:vs-placeholder="$t('Object.Label')"
					v-model.trim="fieldName"
					@keyup.13="setValue"
					class="w-full"
				/>
			</div>

			<div class="mt-2">
				<label class="vs-input--label">{{ $t("Object.Required") }}</label>
				<vs-switch class="mt-2" color="success" v-model="fieldRequired" />
			</div>

			<div class="mt-2" v-if="field.type.value === 'select'">
				<small class="date-label">{{ $t("Object.Options") }}</small>
				<!-- Append Button -->
				<vx-input-group class="mb-2">
					<vs-input
						:placeholder="$t('Object.OptionsLabel')"
						:vs-placeholder="$t('Object.OptionsLabel')"
						v-model="optionName"
						@keyup.13="addSelectOptions"
					/>

					<template slot="append">
						<div class="append-text border border-solid d-theme-border-grey-light">
							<input type="color" v-model="optionColor" name="" value="#A00E0E" class="cursor-pointer" />
						</div>
						<div class="append-text btn-addon">
							<vs-button color="primary" @click="addSelectOptions">{{ $t("Add") }}</vs-button>
						</div>
					</template>
				</vx-input-group>
				<!-- /Append Button -->
				<div class="mb-base">
					<vue-perfect-scrollbar class="scroll-area--content-options" :settings="settings">
						<vs-chip
							@click="remove(option)"
							v-for="(option, index) in fieldSelectOptions"
							:key="index"
							closable
							:color="option.color"
						>
							{{ option.value }}
						</vs-chip>
					</vue-perfect-scrollbar>
				</div>
			</div>

			<div class="mt-2" v-if="field.type.value === 'check'">
				<small class="date-label">{{ $t("Add") + " " + $t("Options") }}</small>
				<!-- Append Button -->
				<vx-input-group class="mb-2">
					<vs-input
						:placeholder="$t('DesignConfig.Option')"
						v-model="optionName"
						@keyup.13="addCheckOptions"
					/>

					<template slot="append">
						<div class="append-text btn-addon">
							<vs-button
								color="primary"
								@click="addCheckOptions"
								type="filled"
								icon-pack="feather"
								icon="icon-plus-square"
								:title="$t('Add') + ' ' + $t('DesignConfig.Option')"
							></vs-button>
						</div>
					</template>
				</vx-input-group>
				<!-- /Append Button -->
				<div class="mb-base mt-2">
					<vs-list>
						<vs-list-header :title="$t('Options')"></vs-list-header>
						<vue-perfect-scrollbar class="scroll-area--content-options" :settings="settings">
							<vs-list-item :subtitle="option" v-for="(option, index) in checkOptions" :key="index">
								<vs-button
									@click="removeCheckOption(option)"
									type="filled"
									size="small"
									icon-pack="feather"
									icon="icon-trash-2"
									color="danger"
									:title="$t('Crud.Delete')"
								></vs-button>
							</vs-list-item>
						</vue-perfect-scrollbar>
					</vs-list>
				</div>
			</div>
		</vs-prompt>
	</vx-card>
</template>

<script>
import vSelect from "vue-select";
import moduleCategory from "@/store/category/moduleCategory.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {Validator} from "vee-validate";
import {dict} from "./AddItemValidator.js";
// register custom messages
Validator.localize("en", dict);

export default {
	props: {
		schema: {
			type: Object,
			required: true,
		},
		additionalFields: {
			type: Boolean,
		},
		showEditIcon: {
			type: Boolean,
		},
		defaultAction: {
			type: String,
		},
		defaultTipology: {
			type: String,
		},
	},
	components: {
		vSelect,
		VuePerfectScrollbar,
	},
	data() {
		return {
			activePrompt: false,
			activePromptField: false,
			val: "",
			editable: this.additionalFields,
			selectedTipology: {
				label: this.$t("Object.SelectedTipology.label"),
				value: 1,
			},
			selectedName: {
				label: this.$t("Object.SelectSchemeLabel"),
				value: "SELECCIONE_ESQUEMA",
			},
			field: {
				name: "",
				label: "",
				type: {label: this.$t("Object.Field.label"), value: "text"},
			},
			nameOptions: [
				{
					label: this.$t("Object.nameOptions.VISIT_POINT"),
					value: "VISIT_POINT",
				},
				{label: this.$t("Object.nameOptions.RESOURCE"), value: "RESOURCE"},
				{label: this.$t("Object.nameOptions.SCHEDULE"), value: "SCHEDULE"},
				{label: this.$t("Object.nameOptions.LAYER"), value: "LAYER"},
			],
			schemaProperties: [],
			schemaLocal: this.schema, //JSON.parse(JSON.stringify(this.schema)),
			fieldName: "",
			fieldSelectOptions: [],
			optionName: "",
			optionColor: "#9ecc38",
			// perfectscrollbar settings
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			editPropertie: false,
			currentPropertieEdit: null,
			oldPropertieName: "",
			fieldRequired: false,
			additionalOptions: [
				{
					label: this.$t("Object.statusOptions.Text"),
					type: "text",
					icon: "text_format",
				},
				{
					label: this.$t("Object.statusOptions.Number"),
					type: "number",
					icon: "looks_two",
				},
				{
					label: this.$t("Object.statusOptions.Select"),
					type: "select",
					icon: "arrow_drop_down_circle",
				},
				{
					label: this.$t("Object.statusOptions.MultipleChoice"),
					type: "check",
					icon: "check_box",
				},
				{
					label: this.$t("Object.statusOptions.Email"),
					type: "email",
					icon: "alternate_email",
				},
				{
					label: this.$t("Object.statusOptions.Url"),
					type: "url",
					icon: "link",
				},
				{
					label: this.$t("Object.statusOptions.Date"),
					type: "date",
					icon: "today",
				},
				{
					label: `${this.$t("Routing.DeparturePoint")}(${this.$t("Routing.Map.VisitPoints.Deposit")})`,
					type: "location_default",
					icon: "my_location",
				},
				{
					label: this.$t("Object.statusOptions.Coordinates"),
					type: "location",
					icon: "location_on",
				},
				{
					label: this.$t("Object.statusOptions.File"),
					type: "file",
					icon: "attach_file",
				},
				{
					label: this.$t("Object.statusOptions.Image"),
					type: "img",
					icon: "image",
				},
			],
			checkOptions: [],
		};
	},
	computed: {
		getRequiredColor() {
			return function (params) {
				if (params) return "success";
				else return "warning";
			};
		},
		isRequired() {
			return function (params) {
				if (params) return this.$t("Object.Yes");
				else return this.$t("Object.Not");
			};
		},
		fieldTypes() {
			let cont_location_default = 0;
			if (this.additionalProperties.length > 0) {
				for (const index in this.additionalProperties) {
					if (this.additionalProperties[index].type === "location_default") {
						cont_location_default++;
					}
				}
			}
			if (this.defaultAction === "LIST") {
				return this.schemaLocal.name === "RESOURCE"
					? cont_location_default >= 1
						? this.additionalOptions.filter(({type}) => type !== "location_default")
						: this.additionalOptions
					: this.additionalOptions.filter(({type}) => type !== "location" && type !== "location_default");
			} else {
				return this.category_local.value === "RESOURCE"
					? cont_location_default >= 1
						? this.additionalOptions.filter(({type}) => type !== "location_default")
						: this.additionalOptions
					: this.additionalOptions.filter(({type}) => type !== "location" && type !== "location_default");
			}
		},
		objectsUpdatePermission() {
			return this.$store.getters.checkPermission("OBJECTS_U");
		},
		objectsDeletePermission() {
			return this.$store.getters.checkPermission("OBJECTS_D");
		},
		listTipologies() {
			const data = this.$store.state.moduleTipology.tipologies;
			return data.map((typology) => {
				return {label: typology.name, value: typology.id};
			});
		},
		nameTipology() {
			const data = this.$store.state.moduleTipology.tipologies;
			if (this.schemaLocal !== null && this.defaultAction === "LIST") {
				const found = data.find((t) => t.id === this.schemaLocal.typology_id);
				return found !== undefined ? found.name : "";
			} else {
				return "";
			}
		},
		additionalFieldsEnable: {
			get() {
				return this.editable;
			},
			set(val) {
				this.editable = val;
			},
		},
		typology_local: {
			get() {
				return {
					label: this.selectedTipology.label,
					value: this.selectedTipology.value,
				};
			},
			set(obj) {
				this.selectedTipology = obj;
			},
		},
		category_local: {
			get() {
				return {
					label: this.selectedName.label,
					value: this.selectedName.value,
				};
			},
			set(obj) {
				this.selectedName = obj;
			},
		},
		numProperties() {
			if (this.schemaLocal.json_properties === undefined) {
				return 0;
			} else {
				return this.schemaLocal.json_properties.length;
			}
		},
		principalProperties() {
			if (this.schemaLocal.json_properties === undefined) {
				return [];
			} else {
				return this.schemaLocal.json_properties.filter(
					(propertie) => !propertie.additional && propertie.name !== "additional_info"
				);
			}
		},
		additionalProperties() {
			if (this.schemaLocal.json_properties === undefined) {
				return [];
			} else {
				return this.schemaLocal.json_properties.filter((propertie) => propertie.additional);
			}
		},
	},
	methods: {
		remove(item) {
			this.fieldSelectOptions.splice(this.fieldSelectOptions.indexOf(item), 1);
		},
		removeCheckOption(item) {
			this.checkOptions.splice(item, 1);
		},
		close() {
			this.fieldName = "";
			this.optionName = "";
			this.fieldSelectOptions = [];
			this.fieldRequired = false;
		},
		genterateRandonColor() {
			let r = () => (Math.random() * 256) >> 0;
			let color = `rgb(${r()}, ${r()}, ${r()})`;
			return color;
			//"#" + Math.floor(Math.random() * 16777215).toString(16);
		},
		getRandomColor() {
			var letters = "0123456789ABCDEF";
			var color = "#";
			for (var i = 0; i < 6; i++) {
				color += letters[Math.floor(Math.random() * 16)];
			}
			return color;
		},
		addSelectOptions() {
			if (this.optionName !== null && this.optionName !== "") {
				const [value, color] = this.optionName.split(":");

				if (color) {
					this.fieldSelectOptions.push({
						value,
						label: value,
						color: color ? color : this.optionColor,
					});
				} else if (!color && this.optionColor !== null) {
					this.fieldSelectOptions.push({
						value,
						label: value,
						color: this.optionColor,
					});
				} else {
					const rondomColor = this.genterateRandonColor();
					this.fieldSelectOptions.push({
						value,
						label: value,
						color: rondomColor,
					});
				}
				this.optionName = "";
				this.optionColor = this.getRandomColor();
			}
		},
		openFieldPromp(field) {
			this.editPropertie = false;
			this.activePromptField = true;
			this.fieldName = "";
			this.optionName = "";
			this.fieldSelectOptions = [];
			this.field.type = {label: field.type, value: field.type};
			this.fieldRequired = false;
		},
		setValue() {
			this.field.name =
				this.field.type.value === "location_default"
					? "location_default"
					: this.fieldName.toLowerCase().replaceAll(" ", "_");
			this.field.label = this.fieldName;
			if (this.field.type.value === "select" && this.fieldSelectOptions.length <= 0) {
				this.activePromptField = true;
				return;
			}
			if (this.field.name.length <= 0) {
				this.activePromptField = true;
				return;
			}
			this.activePromptField = false;
			this.add();
		},
		getDataSchemaCategory() {
			this.$emit("printHello", this.schemaLocal, this.category_local);
		},
		openLoadingInDiv() {
			this.$vs.loading({
				container: "#div-with-loading",
				scale: 0.6,
			});
		},
		async getSchema(category) {
			//this.schemaProperties = [];
			this.openLoadingInDiv();
			const body = {
				category,
			};
			try {
				const result = await this.$store.dispatch("moduleCategory/getCategorySchema", body);
				if (Array.isArray(result)) {
					return;
				}
				this.schemaLocal = result.data;
				this.$vs.loading.close("#div-with-loading > .con-vs-loading");
				this.additionalFieldsEnable = true;
			} catch (error) {
				console.error(error);
			}
		},
		createCategory() {
			// Actualizamos las propiedades adicionales que son requeridas
			const requiredAdditional = this.schemaLocal.json_properties
				.filter((prop) => prop.additional && prop.required)
				.map((prop) => prop.name);
			this.schemaLocal.json_base.properties.additional_info.required = requiredAdditional;

			const payload = {
				...this.schemaLocal,
				name: this.category_local.value,
				typology_id: this.typology_local.value,
			};

			this.$store.dispatch("moduleCategory/addCategory", payload).then((response) => {
				this.schemaLocal.id = response.data.id;
				this.$vs.notify({
					color: "success",
					title: this.$t("TitleConfirmCategoryCreate"),
					text: this.$t("TextConfirmCategoryCreate"),
				});
			});
		},
		updateCategory() {
			// Actualizamos las propiedades adicionales que son requeridas
			const requiredAdditional = this.schemaLocal.json_properties
				.filter((prop) => prop.additional && prop.required)
				.map((prop) => prop.name);
			this.schemaLocal.json_base.properties.additional_info.required = requiredAdditional;

			this.$store.dispatch("moduleCategory/updateCategory", {...this.schemaLocal}).then((response) => {
				this.$vs.notify({
					color: "success",
					title: this.$t("TitleConfirmCategoryUpdate"),
					text: this.$t("TextConfirmCategoryUpdate"),
				});
				this.additionalFieldsEnable = false;
			});
		},
		updateCategoryFromDefinition(id) {
			const payload = {
				...this.schemaLocal,
				typology_id: id,
			};
			this.$store.dispatch("moduleCategory/updateCategory", payload).then((response) => {
				this.$vs.notify({
					color: "success",
					title: this.$t("TitleConfirmCategoryUpdate"),
					text: this.$t("TextConfirmCategoryUpdate"),
				});
			});
		},
		deleteCategory() {
			this.$store.dispatch("moduleCategory/removeCategory", this.schemaLocal.id).then((response) => {
				this.$vs.notify({
					color: "success",
					title: this.$t("TitleConfirmCategoryDelete"),
					text: this.$t("TextConfirmCategoryDelete"),
				});
				return response;
			});
		},
		confirmDeleteCategory() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text:
					this.$t("Object.DeleteObject.Text1") +
					` "${this.nameTipology}"? ` +
					this.$t("Object.DeleteObject.Text2"),
				accept: this.deleteCategory,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		formatObj(newField) {
			const obj = {};
			const validateRequired = (required) => (required ? ["string"] : ["string", "null"]); // no required ["string","null"], required = ["string"]
			const validateRequiredNum = (required) => (required ? ["number"] : ["number", "null"]); // no required ["number","null"], required = ["number"]

			switch (newField.type) {
				case "select":
					obj.enum = newField.required
						? newField.options.map(({value}) => value)
						: ["", null].concat(newField.options.map(({value}) => value));
					obj.type = validateRequired(newField.required);
					break;
				case "location":
				case "text":
					obj.minLength = newField.required ? 1 : 0;
					obj.type = validateRequired(newField.required);
					break;
				case "number":
					obj.type = validateRequiredNum(newField.required);
					break;
				case "email":
					obj.pattern =
						"^([a-z0-9-+*=&'/?^_}{~|`]+)(.?[a-z0-9-+*=&'/?^_}{~|`]+)*@[a-z0-9]+((-|.)[a-z0-9]+)*(.[a-z0-9]{1,20})$";
					obj.type = validateRequired(newField.required);
					break;
				case "url":
				case "file":
				case "img":
					obj.format = "uri";
					obj.type = validateRequired(newField.required);
					break;
				case "date":
					obj.format = "date";
					obj.type = validateRequired(newField.required);
					break;
				case "check":
					obj.items = {
						enum: newField.options.map((value) => value),
						type: validateRequired(newField.required),
					};
					obj.type = "array";
					break;
				case "location_default":
					obj.pattern =
						"^(\\+|-)?(0.0|(0|[1-8]?[0-9]).\\d{5,}|90.\\d[0]{4,}),(\\+|-)?(0.0|(0|[1-9][0-9]?|1[0-7][0-9]).\\d{5,}|180.\\d[0]{4,})$";
					obj.type = validateRequired(newField.required);
					break;
				default:
					break;
			}
			return obj;
		},
		add() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const newField = {
						...this.field,
						type: this.field.type.value,
						additional: true,
						required: this.fieldRequired,
					};
					if (newField.type === "select") {
						newField["options"] = this.fieldSelectOptions;
					}

					if (newField.type === "check") {
						newField["options"] = this.checkOptions.map((op) => op);
					}

					if (this.defaultAction === "CREATE" || this.defaultAction === "DEFINITION") {
						this.addItemToCreate(newField);
					}
					if (this.defaultAction === "LIST") {
						this.addItemToUpdate(newField);
					}
				} else {
					this.$vs.notify({
						color: "danger",
						title: this.$t("Object.ErrorFields.Title"),
						text: this.$t("Object.ErrorFields.Text"),
					});
				}
			});
		},
		addItemToCreate(newField) {
			this.setAdditionalInfo(newField);
		},
		addItemToUpdate(newField) {
			newField.id = this.schemaLocal.id;
			if (this.editPropertie) {
				this.deleteRecord(this.currentPropertieEdit);
			}
			this.$store.dispatch("moduleCategory/addNewField", newField).then((response) => {
				this.clearFieldForm();
			});
		},
		clearFieldForm() {
			this.field = {
				name: "",
				label: "",
				type: {label: this.$t("Object.statusOptions.Text"), value: "text"},
			};
		},
		setAdditionalInfo(newField) {
			const obj = this.formatObj(newField);
			if (this.editPropertie) {
				this.deleteRecord(this.currentPropertieEdit);
			}

			if (newField.required) {
				this.schemaLocal.json_base.properties.additional_info.required.push(newField.name);
			}
			this.schemaLocal.json_base.properties.additional_info.properties[newField.name] = obj;
			this.schemaLocal.json_properties.push(newField);
			this.clearFieldForm();
		},
		confirmDeleteField(field) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Object.DeleteField.Text1") + ` "${field.name}"? ` + this.$t("Object.DeleteField.Text2"),
				accept: () => {
					this.deleteRecord(field);
				},
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord(field) {
			if (this.defaultAction === "DEFINITION") {
				this.deleteFromDefinition(field);
			}
			if (this.defaultAction === "LIST") {
				this.deleteFromStore(field);
			}
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("Object.UserDeleted.Title"),
				text: this.$t("Object.UserDeleted.Text"),
			});
		},
		editSelect(val) {
			this.editPropertie = true;
			const object = JSON.parse(JSON.stringify(val));
			this.activePromptField = true;
			this.fieldName = object.label;
			this.optionName = "";
			this.fieldRequired = val.required;

			if (object.type === "select") {
				this.fieldSelectOptions = object.options;
			} else if (object.type === "check") {
				this.checkOptions = [...object.options];
			} else {
				this.fieldSelectOptions = [];
			}
			this.field.type = {label: object.type, value: object.type};
			this.oldPropertieName = object.label;
			this.currentPropertieEdit = val;
		},
		deleteFromDefinition(field) {
			const i = this.schemaLocal.json_base.properties.additional_info.required.findIndex((e) => e === field.name);
			this.schemaLocal.json_base.properties.additional_info.required.splice(i, 1);
			delete this.schemaLocal.json_base.properties.additional_info.properties[field.name];
			const j = this.schemaLocal.json_properties.findIndex((e) => e.name === field.name);
			this.schemaLocal.json_properties.splice(j, 1);
		},
		deleteFromStore(field) {
			field.id = this.schemaLocal.id;
			this.$store
				.dispatch("moduleCategory/removeAdditionalField", field)
				.then(() => {})
				.catch((err) => {
					console.error(err);
				});
		},
		updateTypology() {
			let regex = /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+$/g;
			let regexEval = regex.test(this.val.trim());
			if (!regexEval) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("Object.UserInvalid.Title"),
					text: this.$t("Object.UserInvalid.Text"),
				});
				return;
			}
			const dataT = this.$store.state.moduleTipology.tipologies;
			let found;
			if (this.schemaLocal !== null && this.defaultAction === "LIST") {
				found = dataT.find((t) => t.id === this.schemaLocal.typology_id);
			}
			const tipologyUpdate = {...found};
			tipologyUpdate.name = this.val.trim();
			this.$store
				.dispatch("moduleTipology/updateTipology", tipologyUpdate)
				.then(() => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCategoryUpdate"),
						text: this.$t("TextConfirmCategoryUpdate"),
					});
				})
				.catch((err) => {
					console.error(err);
				});
		},
		addCheckOptions() {
			if (this.checkOptions.includes(this.optionName) || this.optionName.trim().length <= 0) return;
			this.checkOptions.unshift(this.optionName);
			this.optionName = "";
		},
	},
	watch: {
		category_local(obj) {
			this.getSchema(obj.value);
			this.schemaLocal.name = obj.value;
			this.$emit("selectedSchemaEmit", obj);
		},
		activePrompt(val) {
			val ? (this.val = this.nameTipology) : (this.val = "");
		},
		activePromptField(val) {
			if (val) this.optionColor = this.getRandomColor();
		},
	},

	mounted() {
		const vxCardTitle = document.querySelectorAll(".card-primary .vx-card__header .vx-card__title h4");
		const vxCardTitle2 = document.querySelectorAll(".card-secondary .vx-card__header .vx-card__title h4");
		if (vxCardTitle.length > 0) {
			for (let i = 0; i < vxCardTitle.length; i++) {
				vxCardTitle[i].setAttribute(
					"style",
					"font-style: normal;\n" +
						"    font-weight: bold;\n" +
						"    font-size: 18px;\n" +
						"    line-height: 22px;\n" +
						"    color: #C4C4C4"
				);
			}
		}
		if (vxCardTitle2.length > 0) {
			for (let i = 0; i < vxCardTitle2.length; i++) {
				vxCardTitle2[i].setAttribute(
					"style",
					"font-style: normal;\n" +
						"    font-weight: bold;\n" +
						"    font-size: 14px;\n" +
						"    line-height: 16px;\n" +
						"    color: #484848"
				);
			}
		}
		const foundSelectedTipology = this.listTipologies.find((t) => t.label === this.defaultTipology);
		if (foundSelectedTipology !== undefined) this.selectedTipology = foundSelectedTipology;
	},
	created() {
		if (!moduleCategory.isRegistered) {
			this.$store.registerModule("moduleCategory", moduleCategory);
			moduleCategory.isRegistered = true;
		}
	},
};
</script>

<style lang="scss" scoped>
.scroll-area--content-options {
	margin: auto;
	width: 100%;
	min-height: auto;
	max-height: 150px;
}
</style>
